module.exports = __webpack_public_path__ + "static/media/documents.bc3905d9.svg";